import styled from 'styled-components';

export const Panel = styled.div`
  background-color: ${({ theme }) => theme.color.additional.light.value};
  box-sizing: border-box;
  color: ${({ theme }) => theme.color.additional.dark.value};
  margin: 0;
  padding: 0;
  width: 100%;
`;
